<template>
	<div class="page-barcode-record">
		<!-- 顶部统计 + 切换按钮 -->
		<div class="top-bar">
			<div class="top-total">
				<div>累计关联：{{ totalCount }}台</div>
				<div class="top-tip">按批次号展示</div>
			</div>
			<!-- <div class="top-tabs">
				<div :class="['tab-btn', { active: mode === 'submit' }]" @click="switchMode('submit')">按提交</div>
				<div :class="['tab-btn', { active: mode === 'batch' }]" @click="switchMode('batch')">按批次</div>
			</div> -->
		</div>

		<!-- 按提交列表 -->
		<div class="record-card" v-if="mode === 'submit'">
			<div class="record-table-header">
				<div class="col col-time">时间</div>
				<div class="col col-user">提交人</div>
				<div class="col col-count">提交数量</div>
			</div>
			<div class="record-table-row" v-for="(item, index) in submitList" :key="index">
				<div class="col col-time">
					<div>{{ item.date }}</div>
					<div>{{ item.time }}</div>
				</div>
				<div class="col col-user">{{ item.userName }}</div>
				<div class="col col-count">{{ item.count }}台</div>
			</div>
			<div class="record-loading" v-if="submitList.length">{{ isShowAll ? '已展示全部记录' : '加载中...' }}</div>
			<div class="record-empty" v-if="loaded && !submitList.length">暂无关联记录</div>
		</div>

		<!-- 按批次列表 -->
		<div class="record-card" v-if="mode === 'batch'">
			<div class="record-table-header">
				<div class="col col-batch-no">批次号</div>
				<div class="col col-batch-bound">已关联数量</div>
				<div class="col col-batch-unbound">未关联数量</div>
			</div>
			<div class="record-table-row" v-for="(item, index) in batchList" :key="index">
				<div class="col col-batch-no">{{ item.batchNo }}</div>
				<div class="col col-batch-bound">{{ item.boundCount }}台</div>
				<div class="col col-batch-unbound">{{ item.unboundCount }}台</div>
			</div>
			<div class="record-empty" v-if="batchLoaded && !batchList.length">暂无批次记录</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'XiazengBarcodeBindRecord',
	data() {
		return {
			mode: 'batch',
			totalCount: 0,
			// 按提交
			submitList: [],
			submitPageNo: 1,
			submitTotal: 0,
			isShowAll: false,
			loaded: false,
			// 按批次
			batchList: [],
			batchLoaded: false,
		};
	},
	created() {
		this.loadBatchData();
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		switchMode(mode) {
			if (this.mode === mode) return;
			this.mode = mode;
			if (mode === 'batch' && !this.batchLoaded) {
				this.loadBatchData();
			}
		},

		// 按提交 - 分页加载
		loadSubmitData() {
			const vm = this;
			vm.$http({
				method: 'GET',
				url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/bindRecord',
				params: { pageSize: 20, pageNo: vm.submitPageNo },
			}).then(res => {
				const data = res.data || {};
				vm.totalCount = data.boundCount || 0;
				const records = (data.records && data.records.records) || [];
				records.forEach(item => {
					const timeStr = item.barcodeBindAt || '';
					item.date = timeStr.split(' ')[0] || '-';
					item.time = timeStr.split(' ')[1] || '';
					item.userName = item.operationName || '-';
					item.count = 1;
				});
				vm.submitList = vm.submitPageNo === 1 ? records : vm.submitList.concat(records);
				vm.submitTotal = (data.records && data.records.total) || 0;
				vm.isShowAll = vm.submitList.length >= vm.submitTotal;
				vm.loaded = true;
			}).catch(() => {
				vm.loaded = true;
			});
		},

		// 按批次 - 一次性加载
		loadBatchData() {
			const vm = this;
			vm.$http({
				method: 'GET',
				url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/bindRecord/byBatch',
			}).then(res => {
				const data = res.data || {};
				vm.totalCount = data.totalBoundCount || 0;
				vm.batchList = data.batches || [];
				vm.batchLoaded = true;
			}).catch(() => {
				vm.batchLoaded = true;
			});
		},

		// 滚动加载更多（仅按提交模式）
		handleScroll() {
			const vm = this;
			if (vm.mode !== 'submit' || vm.isShowAll) return;
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			const scrollHeight = document.documentElement.scrollHeight;
			const clientHeight = document.documentElement.clientHeight;
			if (scrollTop + clientHeight >= scrollHeight - 50) {
				vm.submitPageNo++;
				vm.loadSubmitData();
			}
		},
	},
};
</script>

<style lang="less" scoped>
@import '@/less/base.less';

.page-barcode-record {
	min-height: 100vh;
	background: @bgColor2;
	padding-bottom: 0.2rem;
	box-sizing: border-box;

	.top-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0.2rem 0.1rem;

		.top-total {
			color: @textColor1;
			font-size: 0.18rem;
			font-weight: 500;
			letter-spacing: 0.01rem;

			.top-tip {
				font-size: 0.14rem;
				color: @textColor13;
				font-weight: normal;
				margin-top: 0.05rem;
			}
		}

		.top-tabs {
			display: flex;

			.tab-btn {
				border-radius: 0.25rem;
				font-size: 0.15rem;
				letter-spacing: 0.01rem;
				line-height: 0.3rem;
				padding: 0 0.14rem;
				margin-left: 0.1rem;
				cursor: pointer;
				border: 2px solid @textColor1;
				color: @textColor1;
				background: transparent;

				&.active {
					background: @themeColor;
					border-color: @themeColor;
					color: @blank;
				}
			}
		}
	}

	.record-card {
		background: @blank;
		border-radius: 0.05rem;
		margin: 0 0.1rem;
		overflow: hidden;

		.record-table-header {
			display: flex;
			border-bottom: 1px solid @borderColor1;

			.col {
				color: @textColor12;
				font-size: 0.16rem;
				font-weight: 500;
				padding: 0.13rem 0.1rem;
				letter-spacing: 0.01rem;
			}
		}

		.record-table-row {
			display: flex;
			border-bottom: 1px solid @borderColor1;

			&:last-child {
				border-bottom: none;
			}

			.col {
				color: @textColor1;
				font-size: 0.15rem;
				padding: 0.12rem 0.1rem;
				letter-spacing: 0.01rem;
			}
		}

		// 按提交模式列宽
		.col-time {
			flex: 3;
		}
		.col-user {
			flex: 2;
		}
		.col-count {
			flex: 2;
		}

		// 按批次模式列宽
		.col-batch-no {
			flex: 1;
		}
		.col-batch-bound {
			flex: 1;
		}
		.col-batch-unbound {
			flex: 1;
		}

		.record-loading {
			text-align: center;
			font-size: 0.14rem;
			color: @textColor13;
			padding: 0.12rem 0;
		}

		.record-empty {
			padding: 0.4rem;
			text-align: center;
			color: @textColor13;
			font-size: 0.16rem;
		}
	}
}
</style>
